'use strict';

import './singles/webfonts';
